/* eslint-disable react/no-unused-prop-types */
import React, { FunctionComponent, useEffect, useState, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { MainInput } from '../MainInput';

export interface FilterSelectConfig {
  component: any;
  rowIdKey: string;
  path: string;
}

interface FilterLibbyObject {
  [k: string]: { path: string; value: any; method?: string }[];
}

interface FilterTableProps {
  config: any;
  handleChangeFilter: (value: FilterLibbyObject) => void;
}

export const FilterTable: FunctionComponent<FilterTableProps> = ({
  config,
  handleChangeFilter,
}) => {
  const { simpleSelectConfig, inputConfig } = config;
  const [filterValues, setFilterValues] = useState<{ [key: string]: string }>({});
  const [searchInputValue, setSearchInputValue] = useState('');

  const onChange = (e: React.FormEvent<EventTarget>) => {
    const target = e.target as HTMLInputElement;
    setFilterValues({
      ...filterValues,
      [target.name]: target.value,
    });
  };

  const onFilter = useCallback(() => {
    const isSomeFilter = Object.keys(filterValues).find(
      (key) => filterValues[key as keyof typeof filterValues],
    );

    const toObjectLibby: FilterLibbyObject = {};

    if (isSomeFilter) {
      Object.keys(filterValues).forEach((key) => {
        if (!filterValues[key]) return;
        const value = filterValues[key];
        const { path } = simpleSelectConfig.find(
          ({ rowIdKey }: FilterSelectConfig) => rowIdKey === key,
        );
        if (toObjectLibby[key]) {
          toObjectLibby[key].push({ path, value });
        } else {
          toObjectLibby[key] = [{ path, value }];
        }
      });
    }
    if (searchInputValue) {
      const { path } = inputConfig;
      if (typeof path === 'string') {
        toObjectLibby.input = [{ path, value: searchInputValue }];
      } else {
        toObjectLibby.input = path.map((item: string) => ({ path: item, value: searchInputValue }));
      }
    }
    handleChangeFilter(toObjectLibby);
  }, [filterValues, searchInputValue, handleChangeFilter, inputConfig, simpleSelectConfig]);

  useEffect(() => {
    onFilter();
  }, [onFilter]);

  return (
    <Grid container justify="flex-start" spacing={2} alignItems="center">
      <Grid item xs={8}>
        <Grid container justify="flex-start" spacing={2} alignItems="center">
          {simpleSelectConfig.map(({ component, rowIdKey }: FilterSelectConfig) => {
            const Component = component;

            return (
              <Grid item xs={3}>
                <Component
                  value={filterValues[rowIdKey as keyof typeof filterValues]}
                  handleChange={onChange}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>

      <Grid item xs={1} />

      {inputConfig && (
        <Grid item xs={3}>
          <MainInput
            customStyle={customStyleInput}
            value={searchInputValue}
            handleChange={(e) => setSearchInputValue(e.target.value)}
            placeholder="Buscar"
            fullWidth
          />
        </Grid>
      )}
    </Grid>
  );
};

const customStyleInput = { marginTop: 28, height: 51, width: '100%' };
